import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/App'
import { initSentry } from '@/lib/sentry'
import '@/styles/app.css'

initSentry()

const root = document.getElementById('root')

if (root === null) {
    throw new Error('Das Wurzelelement #root fehlt in index.html.')
}

createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
)
